import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cgs',
  templateUrl: './cgs.component.html',
  styleUrls: ['./cgs.component.scss']
})
export class CgsComponent implements OnInit {
  @Output() langChange = new EventEmitter<string>();

  frenchCgs:boolean = false;
  englishCgs:boolean = false;
  
  baseHref: string;
  htmlString: any;
  constructor() { }

  ngOnInit() {
    var base = document.getElementsByTagName('base');
    this.baseHref = base[0].href + "assets/cgs/cgs";
    
    if(navigator.language.includes('fr')){
      this.frenchCgs = true;
    } else {
      this.englishCgs = true;
    }
  }
  
  loadEnglishCgs(){
    if(this.frenchCgs == true){
      this.frenchCgs = false;
      this.englishCgs = true;
      this.langChange.next('en');
    }
  } 
  
  loadFrenchCgs(){
    if(this.englishCgs == true){
      this.englishCgs = false;
      this.frenchCgs = true;
      this.langChange.next('fr');
    }
  }

  
  getParamsInURL(language: string) {
    if(language == "fr")
      window.open(this.baseHref + "-FR.pdf");
    if(language == "en")
      window.open(this.baseHref + "-EN.pdf");
  }


}
